import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=27c7852a&scoped=true"
import script from "./MHeader.vue?vue&type=script&lang=js"
export * from "./MHeader.vue?vue&type=script&lang=js"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=27c7852a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7852a",
  null
  
)

export default component.exports